import { render } from "./Contact.vue?vue&type=template&id=b6e04c98"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gestx.ztech.ci/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__